module.exports = __webpack_public_path__ + "images/common/star_bg_d21011b4c5684beae4aaedfaeb5ebded.png";